import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/user.svg'
import _imports_1 from '../../../assets/icons/house.svg'
import _imports_2 from '../../../assets/icons/info-icon-transparent.svg'
import _imports_3 from '../../../assets/images/invite-banner.png'
import _imports_4 from '../../../assets/images/dashboard-img.png'
import _imports_5 from '../../../assets/icons/pin-location.svg'
import _imports_6 from '../../../assets/icons/star-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-075bbc27"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invite_contractor_wrapper md:!tw-h-full" }
const _hoisted_2 = {
  key: 0,
  class: "md:!tw-mt-16"
}
const _hoisted_3 = {
  key: 1,
  class: "invite_contractor md:!tw-mt-0"
}
const _hoisted_4 = { class: "invite_contractor__header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invite_contractor__title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Your Project")
], -1))
const _hoisted_6 = { class: "invite_contractor__summary__title" }
const _hoisted_7 = { class: "left_block" }
const _hoisted_8 = { class: "commercial" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Commercial", -1))
const _hoisted_11 = { class: "residential" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "right_block" }
const _hoisted_14 = { class: "invite_contractor__summary__content" }
const _hoisted_15 = { class: "invite_contractor__summary__footer" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "invite_contractor__banner"
}
const _hoisted_18 = { class: "left_block md:!tw-w-full" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Invite contractors from your network", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Invite contractors from your network to work on Your projects", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "right_block" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1))
const _hoisted_22 = { class: "invite_contractor__list" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Your Contractor Network", -1))
const _hoisted_24 = {
  key: 0,
  class: "invite_contractor__list__cards"
}
const _hoisted_25 = { class: "invite_contractor__list__card__item__header" }
const _hoisted_26 = { class: "inner__content" }
const _hoisted_27 = { class: "contractor__img" }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  src: _imports_4,
  class: "tw-rounded-md",
  alt: ""
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_31 = { class: "contractor__info" }
const _hoisted_32 = { class: "contractor__info__summary" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("$22 "),
  /*#__PURE__*/_createElementVNode("span", null, "/hr")
], -1))
const _hoisted_34 = {
  key: 0,
  class: "contractor_location"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1))
const _hoisted_36 = { class: "contractor__info__summary__footer" }
const _hoisted_37 = { class: "left_block" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "|", -1))
const _hoisted_40 = { class: "right_block" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Currently Available", -1))
const _hoisted_42 = { class: "invite_contractor__list__card__item__content" }
const _hoisted_43 = {
  key: 0,
  class: "experience__tag"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Experience", -1))
const _hoisted_45 = {
  key: 1,
  class: "contract_service_tag"
}
const _hoisted_46 = ["src"]
const _hoisted_47 = {
  key: 0,
  class: "custom_tags__more"
}
const _hoisted_48 = {
  key: 0,
  class: "invite_contractor__description"
}
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = { class: "footer__buttons" }
const _hoisted_51 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_EmergencyChip = _resolveComponent("EmergencyChip")!
  const _component_StandardChip = _resolveComponent("StandardChip")!
  const _component_RoutineChip = _resolveComponent("RoutineChip")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ConfirmContractorInvitationModal = _resolveComponent("ConfirmContractorInvitationModal")!
  const _component_ShowInvitedModal = _resolveComponent("ShowInvitedModal")!
  const _component_AddPreferredContractorModal = _resolveComponent("AddPreferredContractorModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createVNode(_component_Loader, null, null, 512), [
            [_vShow, true]
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_v_card, { class: "invite_contractor__summary" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }),
                      _hoisted_10
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      }),
                      _createElementVNode("p", null, _toDisplayString($setup.projectDetails?.projectProperties?.length) + " Property", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    ($setup.projectDetails?.type === $setup.ProjectTypesEnum.EMERGENCY)
                      ? (_openBlock(), _createBlock(_component_EmergencyChip, { key: 0 }))
                      : _createCommentVNode("", true),
                    ($setup.projectDetails?.type === $setup.ProjectTypesEnum.STANDARD)
                      ? (_openBlock(), _createBlock(_component_StandardChip, { key: 1 }))
                      : _createCommentVNode("", true),
                    ($setup.projectDetails?.type === $setup.ProjectTypesEnum.ROUTINE)
                      ? (_openBlock(), _createBlock(_component_RoutineChip, { key: 2 }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h5", null, _toDisplayString($setup.projectDetails?.name), 1),
                  _createElementVNode("p", null, "Project ID: #" + _toDisplayString($setup.projectDetails?.refId), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_v_checkbox, {
                    label: "Invite Only Project",
                    modelValue: $setup.isInviteOnlyProject,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.isInviteOnlyProject) = $event))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          (!$setup.userPreferredContractor?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _hoisted_20,
                  _createVNode(_component_v_btn, {
                    class: "button button-orange",
                    onClick: $setup.openContractorInvitationModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("invite CONTRAcTORS")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _hoisted_21
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            ($setup.userPreferredContractor?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userPreferredContractor, (contractor) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "invite_contractor__list__card__item",
                      key: contractor.id
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            (contractor.userWorkstation?.publicURL)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: contractor.userWorkstation?.publicURL,
                                  alt: "",
                                  class: "tw-rounded-md"
                                }, null, 8, _hoisted_28))
                              : (_openBlock(), _createElementBlock("img", _hoisted_29))
                          ]),
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("h6", null, _toDisplayString(contractor?.userWorkstation?.name), 1),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("p", null, _toDisplayString($setup.contractorType(
                          contractor.toUser?.userBusinessDetails?.type
                        )), 1),
                              _createTextVNode(" | "),
                              _hoisted_33,
                              _createTextVNode(" | "),
                              (
                        contractor.toUser.userBusinessDetails.businessPostcode
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [
                                        _hoisted_35
                                      ]),
                                      _: 1
                                    }),
                                    _createElementVNode("p", null, _toDisplayString(contractor.toUser.userBusinessDetails.businessPostcode), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => [
                                    _hoisted_38
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("p", null, _toDisplayString(contractor.ratings) + "/5 (" + _toDisplayString(contractor.jobsCompleted) + " Jobs) ", 1)
                              ]),
                              _hoisted_39,
                              _createElementVNode("div", _hoisted_40, [
                                _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                _hoisted_41
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        (contractor?.userWorkstation?.experience)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                              _createElementVNode("p", null, _toDisplayString(contractor?.userWorkstation?.experience) + "+ YEARS", 1),
                              _hoisted_44
                            ]))
                          : _createCommentVNode("", true),
                        (contractor.userWorkstation.userSkill.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getUserSkillList(
                    contractor.userWorkstation.userSkill
                  ).slice(0, 3), (skill) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "custom_tags",
                                  key: skill.id
                                }, [
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [
                                      (skill?.iconName)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: 
                        require('@/assets/category-icons/' +
                          skill?.iconName +
                          '.svg')
                      
                                          }, null, 8, _hoisted_46))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createElementVNode("p", null, _toDisplayString(skill?.label), 1)
                                ]))
                              }), 128)),
                              (
                    $setup.getUserSkillList(contractor.userWorkstation.userSkill)
                      ?.length > 3
                  )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("span", null, " +" + _toDisplayString($setup.getUserSkillList(contractor.userWorkstation.userSkill)
                        ?.length - 3) + " More ", 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (contractor.description)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _createElementVNode("p", {
                              innerHTML: contractor.userWorkstation.description
                            }, null, 8, _hoisted_49)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(_component_v_btn, {
                          class: "button button-purple-border",
                          "append-icon": "mdi-send",
                          disabled: !$setup.isInviteOnlyProject
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("MESSAGE ")
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_v_btn, {
                          class: "button button-orange",
                          onClick: ($event: any) => (
                  $setup.onClickInviteEstimate(
                    contractor?.toUser?.id,
                    contractor?.userWorkstation?.id
                  )
                ),
                          disabled: 
                  $setup.isInviteButtonDisable(
                    contractor?.toUser?.id,
                    contractor?.userWorkstation?.id
                  )
                
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString($setup.isInviteDisable(
                    contractor?.toUser?.id,
                    contractor?.userWorkstation?.id
                  )
                    ? `Invited`
                    : `invite to Estimate`), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick", "disabled"])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_51, [
              (
              $setup.projectDetails?.projectJobStatus?.id ===
                $setup.ProjectJobStatusEnum.DRAFT_PROJECT && !$setup.isProjectLiveClicked
            )
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    class: "button button-orange",
                    onClick: $setup.onPostLiveProjectClick,
                    loading: $setup.isShowPostLiveLoading
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("post live project")
                    ]),
                    _: 1
                  }, 8, ["onClick", "loading"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])),
    ($setup.iShowConfirmationModal)
      ? (_openBlock(), _createBlock(_component_ConfirmContractorInvitationModal, {
          key: 2,
          selectedContractor: $setup.selectedContractor,
          onCloseInviteButtonModal: $setup.closeInviteButtonModal
        }, null, 8, ["selectedContractor", "onCloseInviteButtonModal"]))
      : _createCommentVNode("", true),
    ($setup.isShowInviteModal)
      ? (_openBlock(), _createBlock(_component_ShowInvitedModal, {
          key: 3,
          isInviteOnlyProject: $setup.isInviteOnlyProject,
          onOnCloseInviteModal: $setup.onCloseInviteModal
        }, null, 8, ["isInviteOnlyProject", "onOnCloseInviteModal"]))
      : _createCommentVNode("", true),
    ($setup.isShowAddPreferredContractorModal)
      ? (_openBlock(), _createBlock(_component_AddPreferredContractorModal, {
          key: 4,
          onOnClickCloseTab: $setup.onClickCloseModel
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true)
  ]))
}